export default Object.freeze({
	NetStamps: 'netStamps',
	ShippingLabel812x11: 'shippingLabel812x11',
	ShippingLabel1200: 'shippingLabel1200',
	ShippingLabel512x812: 'shippingLabel512x812',
	Envelope10: 'envelope10',
	Envelope9: 'envelope9',
	EnvelopeA9: 'envelopeA9',
	Envelope6: 'envelope6',
	EnvelopeA2: 'envelopeA2',
	Envelope7: 'envelope7',
	Envelope11: 'envelope11',
	Envelope12: 'envelope12',
	EnvelopeCM3510: 'envelopeCM3510',
	EnvelopeCM3520: 'envelopeCM3520',
	EnvelopeCM3530: 'envelopeCM3530',
	EnvelopeCM3810: 'envelopeCM3810',
	EnvelopeCM3820: 'envelopeCM3820',
	EnvelopeCM3830: 'envelopeCM3830',
	MailingLabelCM3610: 'mailingLabelCM3610',
	MailingLabelCM3710: 'mailingLabelCM3710',
	MailingLabelCM3910: 'mailingLabelCM3910',
	MailingLabelCM3930: 'mailingLabelCM3930',
	MailingLabelSDC3110: 'mailingLabelSDC3110',
	MailingLabelSDC5030: 'mailingLabelSDC5030',
	MailingLabelSDC2200: 'mailingLabelSDC2200',
	Roll4x6: 'roll4x6',
	Roll418x614: 'roll418x614',
	Roll2x7: 'roll2x7',
});
